module.exports = __webpack_public_path__ + "assets/img/onboarding_2.f3349d0b.png";